import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-sm font-medium text-gray-900 w-full" }

import { useStore } from 'vuex';
import { computed } from 'vue';
import { Switch, SwitchGroup, SwitchLabel } from '@headlessui/vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleRawOutput',
  setup(__props) {

const store = useStore();
const showRawOutput = computed({
  get() {
    return store.state.showRawOutput;
  },
  set() {
    store.commit('toggleRawOutput');
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SwitchGroup), {
    as: "div",
    class: "flex items-center"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Switch), {
        modelValue: _unref(showRawOutput),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(showRawOutput) ? (showRawOutput).value = $event : null)),
        class: _normalizeClass([_unref(showRawOutput) ? 'bg-indigo-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2'])
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            "aria-hidden": "true",
            class: _normalizeClass([_unref(showRawOutput) ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'])
          }, null, 2)
        ]),
        _: 1
      }, 8, ["modelValue", "class"]),
      _createVNode(_unref(SwitchLabel), {
        as: "span",
        class: "ml-3 w-full"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})